<template>
  <div class="app-friend-notification">
    <div class="content">
      <slot name="txtBefore"></slot>
      <b-form>
        <b-form-group label="Freund benachrichtigen" label-class="visually-hidden">
          <b-form-group label-for="friend-msisdn">
            <label for="friend-msisdn"><slot name="lblMsisdn">Rufnummer:</slot></label>
            <div class="check-friend-msisdn">
              <b-form-input
                id="friend-msisdn"
                name="msisdn"
                type="text"
                v-model.trim="msisdn_"
                :state="isValid('msisdn')"
                @input="$v.msisdn.$touch"
              >
              </b-form-input>
              <captcha ref="captchaComponent" @captchaCode="updateCaptchaData">
              </captcha>
            </div>
            <div class="btn-check-friend">
              <b-overlay class="btn-next-overlay" :show="loading_" spinner-small>
                <b-button @click="check" class="btn-next" type="button" variant="primary" :disabled="$v.$invalid || loading_ || captchaEmpty_">
                  <slot name="btnNext">Jetzt prüfen</slot>
                </b-button>
              </b-overlay>
            </div>
          </b-form-group>
        </b-form-group>
      </b-form>
      <slot name="txtAfterForm"></slot>
    </div>
    <div class="message-box">
      <b-alert
        v-model="showMessageBox"
        dismissible
      >
        <div v-if='!successState' v-html="message"></div>
        <slot v-if='successState' name="txtIsSuccess">Success</slot>
      </b-alert>
    </div>
    <slot name="txtAfter"></slot>
  </div>
</template>
<script>

import syncProperty from '@/mixins/syncProperty'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { helpers } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
import isValid from '@/mixins/isValid'
import Captcha from '@/components/generic/Captcha'
import { required } from 'vuelidate/src/validators'

const isPhoneNumber = helpers.regex('phoneNumber', /^[+]?[0-9]*$/)

export default {
  name: 'FriendNotification',
  components: { Captcha },
  data () {
    return {
      loading: false,
      showMessageBox: false,
      message: '',
      successState: false,
      captcha: {
        token: '',
        code: ''
      },
      captchaEmpty: true
    }
  },
  updated () {
    this.updateCaptchaData({ captchaCode: this.$refs.captchaComponent.captchaCode, captchaToken: this.$refs.captchaComponent.captcha.token })
  },
  computed: {
    ...mapGetters('activation/info', {
      newCutomer: 'msisdn'
    }),
    loading_: function () {
      return this.loading
    },
    captchaEmpty_: function () {
      return this.captchaEmpty
    }
  },
  mixins: [
    syncProperty('msisdn', 'msisdn_'),
    validationMixin,
    isValid
  ],
  props: {
    processName: String
  },
  validations () {
    return {
      msisdn: {
        isPhoneNumber,
        required
      }
    }
  },
  methods: {
    ...mapActions('friendNotification', [
      'checkReferFriend'
    ]),
    ...mapMutations('friendNotification', [
      'existingCustomerMsisdn'
    ]),
    ...mapMutations('friendNotification', {
      updateStoreCaptcha: 'captcha'
    }),
    setMessage (checkReferFriend) {
      this.showMessageBox = true
      if (checkReferFriend.success) {
        this.successState = true
      } else {
        this.message = checkReferFriend
        this.successState = false
      }
    },
    checkProcess () {
      if (this.processName === 'friendNotification') {
        return {
          newCustomerMsisdn: this.msisdn_,
          processName: this.processName,
          captcha: this.captcha
        }
      } else {
        return {
          existingCustomerMsisdn: this.msisdn_,
          newCustomerMsisdn: this.newCutomer,
          processName: this.processName,
          captcha: this.captcha
        }
      }
    },
    check () {
      this.loading = true
      if (this.msisdn_ !== '' && !this.captchaEmpty_) {
        const me = this
        this.checkReferFriend(me.checkProcess())
          .then((checkReferFriend) => {
            this.showMessageBox = true
            this.setMessage(checkReferFriend)
            if ((typeof checkReferFriend).toLowerCase() !== 'object' || !checkReferFriend.success) {
              this.reloadCaptchaComponent()
            }
            this.loading = false
          })
      } else {
        this.existingCustomerMsisdn(this.msisdn_)
        this.loading = false
      }
    },
    updateCaptchaData (captchaData) {
      this.captcha.code = captchaData.captchaCode
      this.captcha.token = captchaData.captchaToken
      this.$emit('updatedCaptcha', this.captcha)
      this.updateStoreCaptcha(this.captcha)
      this.captchaEmpty = this.captcha.code === ''
    },
    reloadCaptchaComponent () {
      this.$refs.captchaComponent.$apollo.queries.captcha.refresh()
      this.$refs.captchaComponent.captchaCode = ''
      this.updateCaptchaData({ captchaCode: this.$refs.captchaComponent.captchaCode, captchaToken: this.$refs.captchaComponent.captcha.token })
    }
  }
}
</script>
